import { useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import Modal from "../../../../parts/modal-new";

const isValidEmail = (email) => {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const AddMemberModal = () => {
  const { t } = useTranslation("coaching-portal");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const emailValid = isValidEmail(email);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!emailValid || submitted) return;
    setSubmitted(true);
    submit("/coaching-portal/gym-members/add-member", {
      method: "POST",
      body: { email: email.trim().toLowerCase(), name: name.trim() },
    });
    setSubmitted(false);
  };

  return (
    <Modal title={t("gymMembers.addMemberModalTitle")}>
      <div className="body max-w-160">
        <div className="chip info">{t("gymMembers.addMemberInfo")}</div>
        <form onSubmit={handleSubmit}>
          <label htmlFor="add-member-email" className="mt-4">
            {t("membershipList.email")}
          </label>
          <input
            id="add-member-email"
            name="email"
            type="email"
            className="text-input"
            placeholder={t("gymMembers.emailPlaceholder")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            // biome-ignore lint/a11y/noAutofocus: <this input should be autofocused>
            autoFocus
            required
          />
          <label htmlFor="add-member-name" className="mt-4">
            {t("gymMembers.nameOptionalLabel")}
          </label>
          <input
            id="add-member-name"
            name="name"
            type="text"
            className="text-input"
            placeholder={t("gymMembers.namePlaceholder")}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </form>
      </div>
      <footer>
        <button
          data-button-type="primary"
          disabled={!emailValid || submitted}
          onClick={handleSubmit}
          type="submit"
        >
          {submitted ? t("gymMembers.addingMember") : t("gymMembers.addMember")}
        </button>
      </footer>
    </Modal>
  );
};

export default AddMemberModal;
